<template>
  <slot data-bs-toggle="modal" :data-bs-target="'#BatchExtend' + TbtnId"></slot>
  <div
    class="modal fade"
    :id="'BatchExtend' + TbtnId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="background: rgba(0, 0, 0, 0.8)"
  >
    <div class="modal-dialog modal-ext modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            레벨변경 일괄처리
          </h5>
        </div>
        <div
          style="text-align: center"
          class="modal-body"
          v-if="
            students.some(
              (student) =>
                student.subscriptions && !student.subscriptions.length
            )
          "
        >
          리스트에 미사용 혹은 MyPath 또는 ChildU(M) 학생이 있습니다. 작업을 계속할 수
          없습니다.
        </div>
        <div class="modal-body" style="text-align: left" v-else>
          <!--<template v-if="this.$root.guiPerm != 'ROOT'">-->
          <i class="bi bi-info-circle"></i> 변경 이력은 학습변경 관리에서 확인
          가능합니다.<br />
          <i class="bi bi-info-circle" style="line-height: 30px"></i>
          레벨변경에서
          <span style="color: #ff0000">MyPath,ChildU(M)상품은 조회되지 않습니다.</span
          ><!--</template
          >-->
          <template
            v-if="
              students.length &&
              students.some(
                (student, i) =>
                  this.levelRequest['0_record'] &&
                  this.levelRequest[i + '_record'] &&
                  this.levelRequest['0_record'].product !=
                    this.levelRequest[i + '_record'].product
              )
            "
            ><i class="bi bi-info-circle"></i> 한 명 이상의 학생이 서로 다른
            상품(MyPath 혹은 ChildU)이 선택되었습니다. "전체 학생을 첫 번째 학생
            변경레벨로 변경" 버튼을 사용할 수 없습니다.<br
          /></template>
          <template
            ><i class="bi bi-info-circle"></i>
            <strong
              >리스트에 미사용 학생이 있습니다. 작업을 계속할 수
              없습니다.</strong
            ><br
          /></template>
          <!--
          <i class="bi bi-info-circle"></i> MyPath 학생은 변경신청을 할 수
          없으며 MyPath+ChildU 상품 신청 시 ChildU 만 변경됩니다.--><br />
          <span style="font-size: 14px; line-height: 30px"
            ><span style="font-weight: bold">첫번째 학생의 상품을 기준</span
            >으로 모든 상품을 변경합니다.<button
              @click="setFirstSubscription()"
              class="btn btn-danger btn-sm"
            >
              상품변경</button
            ><br
          /></span>

          <span style="font-size: 14px; line-height: 30px"
            ><span style="font-weight: bold">첫번째 학생의 레벨을 기준</span
            >으로 모든 레벨을 변경합니다.<button
              @click="setLevelAsFirst()"
              class="btn btn-warning btn-sm"
              :class="{
                disabled:
                  students.length &&
                  students.some(
                    (student, i) =>
                      this.levelRequest['0_record'] &&
                      this.levelRequest[i + '_record'] &&
                      this.levelRequest['0_record'].product !=
                        this.levelRequest[i + '_record'].product
                  )
                    ? true
                    : false,
              }"
            >
              레벨변경
            </button></span
          >

          <table class="table ims" style="font-size: 12px">
            <thead>
              <tr>
                <th>#</th>
                <th>학생명</th>
                <th>아이디</th>
                <th>이용상품</th>
                <th>유형</th>
                <th>현재레벨</th>
                <th>변경레벨</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, i) in students" v-bind:key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ student.name }}</td>
                <td>{{ student.username }}</td>
                <td>
                  <select
                    class="hidtype"
                    v-model="levelRequest[i + '_record']"
                    v-if="student.subscriptions"
                  >
                    <template
                      :key="subscription.id"
                      v-for="subscription in student.subscriptions"
                    >
                      <option :value="subscription">
                        {{ subscription.productName }}
                      </option>
                    </template>
                  </select>
                  <div class="spinner-border text-primary" role="status" v-else>
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
                <td>
                  <template v-if="levelRequest[i + '_record']">{{
                    levelRequest[i + "_record"].product
                  }}</template>
                </td>
                <td>
                  <template v-if="levelRequest[i + '_record']">{{
                    levelRequest[i + "_record"].level
                  }}</template>
                </td>
                <template
                  v-if="
                    this.$root.guiPerm == 'ROOT' ||
                    this.$root.guiPerm == 'LOCAL1'
                  "
                >
                  <td>
                    <select
                      class="hidtype"
                      v-model="levelRequest[i + '_level']"
                      v-if="levelRequest[i + '_record']"
                    >
                      <option value="RE">초기화</option>
                      <option value="GK">GK</option>
                      <option
                        value="GK_1"
                        v-if="levelRequest[i + '_record'].product == 'ChildU'"
                      >
                        GK_1
                      </option>
                      <option value="GR1">GR1</option>
                      <option value="GR2">GR2</option>
                      <option value="GR3">GR3</option>
                      <option value="GR4">GR4</option>
                      <option value="GR5">GR5</option>
                      <template
                        v-if="levelRequest[i + '_record'].product == 'MYPATH' || levelRequest[i + '_record'].product == 'ChildUM'"
                      >
                        <option value="GR6">GR6</option>
                        <option value="GR7">GR7</option>
                        <option value="GR8">GR8</option>
                        <option value="GR9">GR9</option>
                        <option value="GR10">GR10</option>
                        <option value="GR11">GR11</option>
                        <option value="GR12">GR12</option>
                      </template>                      
                    </select>
                  </td>
                </template>
                <template v-else>
                  <template v-if="this.$root.businesses[0].study_type != 'ALS'">
                    <td>
                      <select
                        class="hidtype"
                        v-model="levelRequest[i + '_level']"
                        v-if="levelRequest[i + '_record']"
                      >
                        <option value="RE">초기화</option>
                        <option value="GK">GK</option>
                        <option
                          value="GK_1"
                          v-if="levelRequest[i + '_record'].product == 'ChildU'"
                        >
                          GK_1
                        </option>
                        <option value="GR1">GR1</option>
                        <option value="GR2">GR2</option>
                        <option value="GR3">GR3</option>
                        <option value="GR4">GR4</option>
                        <option value="GR5">GR5</option>
                        <template
                          v-if="levelRequest[i + '_record'].product == 'MYPATH' || levelRequest[i + '_record'].product == 'ChildUM'"
                        >
                          <option value="GR6">GR6</option>
                          <option value="GR7">GR7</option>
                          <option value="GR8">GR8</option>
                          <option value="GR9">GR9</option>
                          <option value="GR10">GR10</option>
                          <option value="GR11">GR11</option>
                          <option value="GR12">GR12</option>
                        </template>
                      </select>
                    </td>
                  </template>
                  <template v-else>
                    <td>
                      <select
                        class="hidtype"
                        v-model="levelRequest[i + '_level']"
                        v-if="levelRequest[i + '_record']"
                      >
                        <option value="RE">초기화</option>
                        <option value="Sprout">Sprout</option>
                        <option value="Blow">Blow</option>
                        <option value="Flag">Flag</option>
                        <option value="Wing">Wing</option>
                        <option value="Dream">Dream</option>
                        <option value="Royal">Royal</option>
                      </select>
                    </td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
          <div class="flex_center" style="text-align: center">
            <button
              class="btn btn-danger"
              data-bs-dismiss="modal"
              @click="requestLevel()"
            >
              변경하기
            </button>
          </div>
          <div style="text-align: center">
            <span style="color: #ff0000; font-weight: bold"
              >'변경하기' 클릭 시 즉시 변경됩니다.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LevelMultiple",
  props: {
    students: Array,
    btnId: String,
  },

  data: function () {
    return {
      TbtnId: this.btnId || Math.random().toString().substr(2, 5),
      levelRequest: [],
    };
  },
  methods: {
    setFirstSubscription() {
      this.students.forEach((student, i) => {
        this.levelRequest[i + "_record"] = student.subscriptions[0];
      });
    },
    setLevelAsFirst() {
      this.students.forEach((student, i) => {
        if (!i) return;
        this.levelRequest[i + "_level"] = this.levelRequest["0_level"];
      });
    },
    requestLevel() {
      var requests = [];
      this.students.forEach((student, i) => {
        requests.push(
          new Promise((resolve) => {
            if (!this.levelRequest[i + "_record"]) {
              $.notify(
                {
                  // options
                  message:
                    i +
                    "번째 " +
                    student.name +
                    " 이용상품이 선택되지 않았습니다. 건너뜁니다.",
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
              return;
            }

            if (!this.levelRequest[i + "_level"]) {
              $.notify(
                {
                  // options
                  message:
                    i +
                    "번째 " +
                    student.name +
                    " 변경레벨이 선택되지 않았습니다. 건너뜁니다.",
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
              return;
            }

            if (this.levelRequest[i + "_level"] == "RE") {
              this.levelRequest[i + "_level"] =
                this.levelRequest[i + "_record"].level;
            }

            axios
              .patch("/subscriptions/" + this.levelRequest[i + "_record"].id, {
                level: this.levelRequest[i + "_level"],
              })
              .then((response) => {
                if (response.data.error) {
                  $.notify(
                    {
                      // options
                      message:
                        i +
                        "번째 " +
                        student.name +
                        " 변경실패: " +
                        response.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  $.notify(
                    {
                      // options
                      message:
                        i +
                        "번째 " +
                        student.name +
                        (response.data.status == "requested"
                          ? " 변경 요청되었습니다. "
                          : " 변경되었습니다."),
                    },
                    {
                      // settings
                      type: "success",
                      z_index: 9999,
                    }
                  );
                }
              });
          })
        );
      });
    },
  },
};
</script>

<style></style>
